let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fp3Qi")).then(() => parcelRequire('e0SyW'));